export const TabContainerMockData = {
  model: {
    componentId: 'lgcxihxikfpgsunx',
    mboxParameter: 'testMbox',
    headerTag: 'h2',
    trackingDescription: 'tabbing',
    subHeaderTag: 'h3',
    impressionTrack: 'false',
    trackingProperties: {
      enableScrollingBehavior: false,
      trackingDescription: 'tabbing',
      impressionTrack: false,
      description: '',
      trackingContentPosition: 'loc-1',
      atCCeVar48: '',
      rightArrowDesc: '',
      cardLocation: '',
      leftArrowDesc: '',
      clickTrack: true,
      location: '',
      merchandisingCategory: 'nonCobrand',
      impressionCount: false,
      trackingTag: '',
      trackingOfferType: 'offer',
    },
    isAuthor: '',
    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer',
    cqType: 'mi-aem-common-spa/components/content/tabcontainer',
    headerFontSize: 't-title-s',
    tabDetails: [
      {
        nodeName: 'page-0',
        tabName: '<p>US &amp; Canada</p>\r\n',
      },
      {
        nodeName: 'page-1',
        tabName: '<p>Asia &amp; Pacific</p>\r\n',
      },
      {
        nodeName: 'page-2',
        tabName: '<p>Caribbean &amp; Latin America</p>\r\n',
      },
      {
        nodeName: 'page-3',
        tabName: '<p>Europe</p>\r\n',
      },
      {
        nodeName: 'page-4',
        tabName: '<p>Middle East &amp; Africa</p>\r\n',
      },
    ],
    descFontSize: 't-font-m',
    merchandisingCategory: 'nonCobrand',
    impressionCount: 'false',
    contentBlockAlignment: 'center',
    trackingOfferType: 'offer',
    trackingContentPosition: 'loc-1',
    pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
    cqItems: {
      'page-4': {
        ':items': {
          accordioncontaineren: {
            rootHeaderTag: 'h2',
            componentId: 'bdouvojskzzsvjib',
            rootHeaderFontStyle: 't-body-m',
            showExpandCollapseAllControl: false,
            expandAllLabel: 'Expand All',
            impressionTrack: 'false',
            pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
            trackingProperties: {
              enableScrollingBehavior: false,
              trackingDescription: '',
              impressionTrack: false,
              description: '',
              trackingContentPosition: '',
              atCCeVar48: '',
              rightArrowDesc: '',
              cardLocation: '',
              leftArrowDesc: '',
              clickTrack: false,
              location: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: '',
              trackingOfferType: '',
            },
            isAuthor: false,
            ':items': {
              headerListItems: {
                ':type': 'nt:unstructured',
              },
              'card-0': {
                ':items': {
                  cardcarouselcontaine: {
                    componentId: 'stzpeepwka3azbgw',
                    enableTracking: true,
                    headerText: 'Luxury Suites',
                    cardTypes: 'cardlayered',
                    cardCount: 3,
                    noOfCards: 3,
                    pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
                    clickTrackValue: 'Luxury Suites||external',
                    isAuthor: false,
                    headerPrimaryHOneTag: false,
                    ':items': {
                      'card-5': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'kwljkcgcihb3y6lx',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine/card-5/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-0': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'cjkjbdhv6fcc0rdo',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine/card-0/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-4': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'bosmphkgye8wbv2f',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine/card-4/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-3': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'akkeodyr7ir9pqij',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine/card-3/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-2': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'obzwzcdwlr1rlqpv',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine/card-2/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-1': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'dtonevisw9ag28me',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine/card-1/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                    },
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine',
                    ctaProperties: {
                      ctaType: 'primaryButton',
                      linkUrl: '',
                      linkText: '',
                      linkType: 'external',
                      openInANewTab: false,
                    },
                    ':type': 'mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer',
                    headerFontSize: 'large',
                    ':itemsOrder': ['card-0', 'card-1', 'card-2', 'card-3', 'card-4', 'card-5'],
                    itemPath:
                      'root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-0/cardcarouselcontaine',
                    totalNumberOfCards: ['card-0', 'card-1', 'card-2'],
                    location: 'Luxury Suites',
                    alignment: 'center',
                    items: [],
                    noOfCardsTablet: 2,
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['cardcarouselcontaine'],
                columnClassNames: {
                  cardcarouselcontaine: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
              'card-1': {
                ':items': {
                  linkbanner_copy_copy: {
                    noOfColumns: '3',
                    componentId: 'tdjpdjwf2mn6nxyg',
                    headerTag: 'h3',
                    impressionTrack: 'false',
                    linkBannerHeader: 'United States',
                    hideColumDividers: true,
                    trackingProperties: {
                      enableScrollingBehavior: false,
                      trackingDescription: '',
                      impressionTrack: false,
                      description: '',
                      trackingContentPosition: '',
                      atCCeVar48: '',
                      rightArrowDesc: '',
                      cardLocation: '',
                      leftArrowDesc: '',
                      clickTrack: false,
                      location: '',
                      merchandisingCategory: 'nonCobrand',
                      impressionCount: false,
                      trackingTag: '',
                      trackingOfferType: '',
                    },
                    isAuthor: false,
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren/card-1/linkbanner_copy_copy',
                    ':type': 'mi-aem-common-spa/components/content/linkbanner',
                    headerFontSize: 's',
                    columnDetails: [
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Arizona',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'California',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Colorado',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Florida',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Hawaii',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Massachusetts',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Nevada',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'New Jersey',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'New York',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'North Carolina',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Oregon',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Pennsylvania',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                    ],
                    merchandisingCategory: 'nonCobrand',
                    impressionCount: 'false',
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['linkbanner_copy_copy'],
                columnClassNames: {
                  linkbanner_copy_copy: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
            },
            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren',
            ':type': 'mi-aem-common-spa/components/content/accordioncontainerenhanced',
            collapseAllLabel: 'Collapse All',
            ':itemsOrder': ['headerListItems', 'card-0', 'card-1'],
            itemPath: 'root/responsivegrid/responsivegrid/tabcontainer/page-4/accordioncontaineren',
            headerListItems: [
              {
                nodeName: 'card-0',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Middle East</p>\r\n',
                iconPath: '',
              },
              {
                nodeName: 'card-1',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Africa</p>\r\n',
                iconPath: '',
              },
            ],
            headerAlignment: 'left',
            activateDrawerBehavior: false,
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            modelFactory: {},
            wcmMode: 'disabled',
          },
        },
        allowedComponents: {
          components: [],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['accordioncontaineren'],
        columnClassNames: {
          accordioncontaineren: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'page-2': {
        ':items': {
          accordioncontaineren: {
            rootHeaderTag: 'h2',
            componentId: 'rhsgznbkktke4ifl',
            rootHeaderFontStyle: 't-body-m',
            showExpandCollapseAllControl: false,
            expandAllLabel: 'Expand All',
            impressionTrack: 'false',
            pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
            trackingProperties: {
              enableScrollingBehavior: false,
              trackingDescription: '',
              impressionTrack: false,
              description: '',
              trackingContentPosition: '',
              atCCeVar48: '',
              rightArrowDesc: '',
              cardLocation: '',
              leftArrowDesc: '',
              clickTrack: false,
              location: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: '',
              trackingOfferType: '',
            },
            isAuthor: false,
            ':items': {
              headerListItems: {
                ':type': 'nt:unstructured',
              },
              'card-0': {
                ':items': {
                  linkbanner_copy: {
                    noOfColumns: '4',
                    componentId: 'tfeehjeg0fyq2kt3',
                    headerTag: 'h3',
                    impressionTrack: 'false',
                    linkBannerHeader: 'Canada',
                    hideColumDividers: true,
                    trackingProperties: {
                      enableScrollingBehavior: false,
                      trackingDescription: '',
                      impressionTrack: false,
                      description: '',
                      trackingContentPosition: '',
                      atCCeVar48: '',
                      rightArrowDesc: '',
                      cardLocation: '',
                      leftArrowDesc: '',
                      clickTrack: false,
                      location: '',
                      merchandisingCategory: 'nonCobrand',
                      impressionCount: false,
                      trackingTag: '',
                      trackingOfferType: '',
                    },
                    isAuthor: false,
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-0/linkbanner_copy',
                    ':type': 'mi-aem-common-spa/components/content/linkbanner',
                    headerFontSize: 's',
                    columnDetails: [
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Calgary',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Montreal',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: true,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Toronto',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Vancouver',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                    ],
                    merchandisingCategory: 'nonCobrand',
                    impressionCount: 'false',
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['linkbanner_copy'],
                columnClassNames: {
                  linkbanner_copy: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
              'card-1': {
                ':items': {
                  cardcarouselcontaine: {
                    componentId: 'mafztagmiolabcpw',
                    enableTracking: true,
                    headerText: 'Luxury Suites',
                    cardTypes: 'cardlayered',
                    cardCount: 6,
                    noOfCards: 4,
                    pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
                    clickTrackValue: 'Luxury Suites||external',
                    isAuthor: false,
                    headerPrimaryHOneTag: false,
                    ':items': {
                      'card-5': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'twqbkwoizley30ns',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine/card-5/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-0': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'uvsvhxbekstbu6f7',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine/card-0/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-4': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'miehcceqlbtnu0cy',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine/card-4/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-3': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'bhkzeilmrbgpk1ao',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine/card-3/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-2': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'wyhujmqvhp04v31y',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine/card-2/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-1': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'slghsiry10n3pj97',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine/card-1/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                    },
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine',
                    ctaProperties: {
                      ctaType: 'primaryButton',
                      linkUrl: '',
                      linkText: '',
                      linkType: 'external',
                      openInANewTab: false,
                    },
                    ':type': 'mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer',
                    headerFontSize: 'large',
                    ':itemsOrder': ['card-0', 'card-1', 'card-2', 'card-3', 'card-4', 'card-5'],
                    itemPath:
                      'root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren/card-1/cardcarouselcontaine',
                    totalNumberOfCards: ['card-0', 'card-1', 'card-2', 'card-3', 'card-4', 'card-5'],
                    location: 'Luxury Suites',
                    alignment: 'center',
                    items: [],
                    noOfCardsTablet: 2,
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['cardcarouselcontaine'],
                columnClassNames: {
                  cardcarouselcontaine: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
            },
            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren',
            ':type': 'mi-aem-common-spa/components/content/accordioncontainerenhanced',
            collapseAllLabel: 'Collapse All',
            ':itemsOrder': ['headerListItems', 'card-0', 'card-1'],
            itemPath: 'root/responsivegrid/responsivegrid/tabcontainer/page-2/accordioncontaineren',
            headerListItems: [
              {
                nodeName: 'card-0',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Caribbean</p>\r\n',
                iconPath: '',
              },
              {
                nodeName: 'card-1',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Latin America</p>\r\n',
                iconPath: '',
              },
            ],
            headerAlignment: 'left',
            activateDrawerBehavior: true,
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            modelFactory: {},
            wcmMode: 'disabled',
          },
        },
        allowedComponents: {
          components: [],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['accordioncontaineren'],
        columnClassNames: {
          accordioncontaineren: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'page-3': {
        ':items': {
          accordioncontaineren: {
            rootHeaderTag: 'h2',
            componentId: 'sdpkctsrd39hfgvi',
            rootHeaderFontStyle: 't-body-m',
            showExpandCollapseAllControl: true,
            expandAllLabel: 'Expand All',
            impressionTrack: 'false',
            pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
            trackingProperties: {
              enableScrollingBehavior: false,
              trackingDescription: '',
              impressionTrack: false,
              description: '',
              trackingContentPosition: '',
              atCCeVar48: '',
              rightArrowDesc: '',
              cardLocation: '',
              leftArrowDesc: '',
              clickTrack: false,
              location: '',
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: '',
              trackingOfferType: '',
            },
            isAuthor: false,
            ':items': {
              headerListItems: {
                ':type': 'nt:unstructured',
              },
              'card-0': {
                ':items': {
                  linkbanner_copy: {
                    noOfColumns: '3',
                    componentId: 'ppdxkxej4dzc2isr',
                    headerTag: 'h3',
                    impressionTrack: 'false',
                    linkBannerHeader: 'United States',
                    hideColumDividers: true,
                    trackingProperties: {
                      enableScrollingBehavior: false,
                      trackingDescription: '',
                      impressionTrack: false,
                      description: '',
                      trackingContentPosition: '',
                      atCCeVar48: '',
                      rightArrowDesc: '',
                      cardLocation: '',
                      leftArrowDesc: '',
                      clickTrack: false,
                      location: '',
                      merchandisingCategory: 'nonCobrand',
                      impressionCount: false,
                      trackingTag: '',
                      trackingOfferType: '',
                    },
                    isAuthor: false,
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-3/accordioncontaineren/card-0/linkbanner_copy',
                    ':type': 'mi-aem-common-spa/components/content/linkbanner',
                    headerFontSize: 's',
                    columnDetails: [
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Arizona',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'California',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Colorado',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Florida',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Hawaii',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Massachusetts',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Nevada',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'New Jersey',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'New York',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'North Carolina',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Oregon',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Pennsylvania',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                    ],
                    merchandisingCategory: 'nonCobrand',
                    impressionCount: 'false',
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['linkbanner_copy'],
                columnClassNames: {
                  linkbanner_copy: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
            },
            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-3/accordioncontaineren',
            ':type': 'mi-aem-common-spa/components/content/accordioncontainerenhanced',
            collapseAllLabel: 'Collapse All',
            ':itemsOrder': ['headerListItems', 'card-0'],
            itemPath: 'root/responsivegrid/responsivegrid/tabcontainer/page-3/accordioncontaineren',
            headerListItems: [
              {
                nodeName: 'card-0',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Europe</p>\r\n',
                iconPath: '',
              },
            ],
            headerAlignment: 'left',
            activateDrawerBehavior: false,
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            modelFactory: {},
            wcmMode: 'disabled',
          },
        },
        allowedComponents: {
          components: [],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['accordioncontaineren'],
        columnClassNames: {
          accordioncontaineren: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'page-0': {
        ':items': {
          accordioncontaineren: {
            rootHeaderTag: 'h2',
            componentId: 'pudbyuvs375v70c1',
            rootHeaderFontStyle: 't-body-m',
            trackingDescription: 'accordion-1-description',
            expandAllLabel: 'Expand All',
            impressionTrack: 'false',
            trackingProperties: {
              enableScrollingBehavior: false,
              trackingDescription: 'accordion-1-description',
              impressionTrack: false,
              description: '',
              trackingContentPosition: 'accordion-1-content',
              atCCeVar48: '',
              rightArrowDesc: '',
              cardLocation: '',
              leftArrowDesc: '',
              clickTrack: true,
              location: 'accordion-1',
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: '',
              trackingOfferType: '',
            },
            isAuthor: false,
            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-0/accordioncontaineren',
            ':type': 'mi-aem-common-spa/components/content/accordioncontainerenhanced',
            collapseAllLabel: 'Collapse All',
            headerListItems: [
              {
                nodeName: 'card-0',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>United States</p>\r\n',
                iconPath: '',
              },
              {
                nodeName: 'card-1',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Canada</p>\r\n',
                iconPath: '',
              },
            ],
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            showExpandCollapseAllControl: false,
            trackingContentPosition: 'accordion-1-content',
            pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
            ':items': {
              headerListItems: {
                ':type': 'nt:unstructured',
              },
              'card-0': {
                ':items': {
                  linkbanner: {
                    noOfColumns: '4',
                    componentId: 'qzuznkmtr2mwo6vv',
                    headerTag: 'h3',
                    impressionTrack: 'false',
                    linkBannerHeader: 'United States',
                    hideColumDividers: true,
                    trackingProperties: {
                      enableScrollingBehavior: false,
                      trackingDescription: '',
                      impressionTrack: false,
                      description: '',
                      trackingContentPosition: '',
                      atCCeVar48: '',
                      rightArrowDesc: '',
                      cardLocation: '',
                      leftArrowDesc: '',
                      clickTrack: false,
                      location: '',
                      merchandisingCategory: 'nonCobrand',
                      impressionCount: false,
                      trackingTag: '',
                      trackingOfferType: '',
                    },
                    isAuthor: false,
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-0/accordioncontaineren/card-0/linkbanner',
                    ':type': 'mi-aem-common-spa/components/content/linkbanner',
                    headerFontSize: 's',
                    columnDetails: [
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        header: 'Title 1',
                        linkItems: [
                          {
                            linkLabel: 'Arizona',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'California',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Colorado',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Florida',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Test',
                            linkURL: 'https://author-marriott-sites-stage.adobecqms.net/',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        header: 'Title 2',
                        linkItems: [
                          {
                            linkLabel: 'Hawaii',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Massachusetts',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Nevada',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'New Jersey',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        header: 'Title 3',
                        linkItems: [
                          {
                            linkLabel: 'New York',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'North Carolina',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Oregon',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Pennsylvania',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        header: 'Title 4',
                        linkItems: [
                          {
                            linkLabel: 'Texas',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Utah',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                          {
                            linkLabel: 'Virginia',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                          },
                          {
                            linkLabel: 'Washington',
                            linkURL: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: false,
                          },
                        ],
                      },
                    ],
                    merchandisingCategory: 'nonCobrand',
                    impressionCount: 'false',
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['linkbanner'],
                columnClassNames: {
                  linkbanner: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
              'card-1': {
                ':items': {
                  linkbanner: {
                    noOfColumns: '4',
                    componentId: 'obblucgxzswpr7np',
                    headerTag: 'h3',
                    impressionTrack: 'false',
                    linkBannerHeader: 'Canada',
                    hideColumDividers: true,
                    trackingProperties: {
                      enableScrollingBehavior: false,
                      trackingDescription: '',
                      impressionTrack: false,
                      description: '',
                      trackingContentPosition: '',
                      atCCeVar48: '',
                      rightArrowDesc: '',
                      cardLocation: '',
                      leftArrowDesc: '',
                      clickTrack: false,
                      location: '',
                      merchandisingCategory: 'nonCobrand',
                      impressionCount: false,
                      trackingTag: '',
                      trackingOfferType: '',
                    },
                    isAuthor: false,
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-0/accordioncontaineren/card-1/linkbanner',
                    ':type': 'mi-aem-common-spa/components/content/linkbanner',
                    headerFontSize: 's',
                    columnDetails: [
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Calgary',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Montreal',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: true,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Toronto',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Vancouver',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                    ],
                    merchandisingCategory: 'nonCobrand',
                    impressionCount: 'false',
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['linkbanner'],
                columnClassNames: {
                  linkbanner: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
            },
            ':itemsOrder': ['card-0', 'card-1', 'headerListItems'],
            itemPath: 'root/responsivegrid/responsivegrid/tabcontainer/page-0/accordioncontaineren',
            headerAlignment: 'left',
            location: 'accordion-1',
            activateDrawerBehavior: false,
            modelFactory: {},
            wcmMode: 'disabled',
          },
        },
        allowedComponents: {
          components: [],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['accordioncontaineren'],
        columnClassNames: {
          accordioncontaineren: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
      'page-1': {
        ':items': {
          accordioncontaineren: {
            rootHeaderTag: 'h2',
            componentId: 'wmzucscx6n49ad6k',
            rootHeaderFontStyle: 't-body-m',
            trackingDescription: 'accordion-2-description',
            expandAllLabel: 'Expand All',
            impressionTrack: 'false',
            trackingProperties: {
              enableScrollingBehavior: false,
              trackingDescription: 'accordion-2-description',
              impressionTrack: false,
              description: '',
              trackingContentPosition: 'accordion-2-content',
              atCCeVar48: 'cc-accordion',
              rightArrowDesc: '',
              cardLocation: '',
              leftArrowDesc: '',
              clickTrack: true,
              location: 'accordion-2',
              merchandisingCategory: 'nonCobrand',
              impressionCount: false,
              trackingTag: '',
              trackingOfferType: 'offer-accordion',
            },
            isAuthor: false,
            atCCeVar48: 'cc-accordion',
            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren',
            ':type': 'mi-aem-common-spa/components/content/accordioncontainerenhanced',
            collapseAllLabel: 'Collapse All',
            headerListItems: [
              {
                nodeName: 'card-0',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Asia</p>\r\n',
                iconPath: '',
              },
              {
                nodeName: 'card-1',
                drawerHeaderTag: 'h2',
                dynamicMedia: null,
                assetVariation: 'image',
                header: '<p>Pacific</p>\r\n',
                iconPath: '',
              },
            ],
            merchandisingCategory: 'nonCobrand',
            impressionCount: 'false',
            trackingOfferType: 'offer-accordion',
            showExpandCollapseAllControl: false,
            trackingContentPosition: 'accordion-2-content',
            pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
            ':items': {
              headerListItems: {
                ':type': 'nt:unstructured',
              },
              'card-0': {
                ':items': {
                  cardcarouselcontaine: {
                    componentId: 'rdjixxhpvd4nvr21',
                    enableTracking: true,
                    headerText: 'Luxury Suites',
                    cardTypes: 'cardlayered',
                    cardCount: 3,
                    noOfCards: 3,
                    pagePath: '/content/mi-luxury-spa/na/en-us/about-us/editorial',
                    clickTrackValue: 'Luxury Suites||external',
                    isAuthor: false,
                    headerPrimaryHOneTag: false,
                    ':items': {
                      'card-0': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'lwsufwgmqnskki34',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren/card-0/cardcarouselcontaine/card-0/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-2': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            componentId: 'lolghcets9c2tt22',
                            headerTag: 'h3',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren/card-0/cardcarouselcontaine/card-2/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TESTING',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            header: 'Man Ho Chinese Restaurant',
                            dynamicMediaWide: {
                              altText: 'TESTING',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7stage/mlexr-wedding-cake-2718-2:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/mlexr-wedding-cake-2718.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: 'https://luxurygrouphotels.com/',
                            openInNewTab: false,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                      'card-1': {
                        ':items': {
                          cardlayered_copy_cop: {
                            dynamicMedia: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Square?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            componentId: 'vhyhiocbfxyl9w1h',
                            headerTag: 'h2',
                            impressionTrack: 'false',
                            cardLayeredVariations: 'square',
                            trackingProperties: {
                              enableScrollingBehavior: false,
                              trackingDescription: '',
                              impressionTrack: false,
                              description: '',
                              trackingContentPosition: '',
                              atCCeVar48: '',
                              rightArrowDesc: '',
                              cardLocation: '',
                              leftArrowDesc: '',
                              clickTrack: false,
                              location: '',
                              merchandisingCategory: 'nonCobrand',
                              impressionCount: false,
                              trackingTag: '',
                              trackingOfferType: '',
                            },
                            isAuthor: false,
                            logoIcon: '',
                            path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren/card-0/cardcarouselcontaine/card-1/cardlayered_copy_cop',
                            dynamicMediaTall: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=380&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=760&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Classic-Ver?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            ':type': 'mi-aem-common-spa/components/content/cardlayered',
                            imgAltText: 'TRX_Vommuli_House',
                            fileReferenceImage:
                              '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            header: 'IGNIV Bangkok',
                            dynamicMediaWide: {
                              altText: 'TRX_Vommuli_House',
                              assetPath:
                                'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686',
                              enableSmartCrop: true,
                              dynamic: true,
                              renditions: [
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=570&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1140&fit=constrain 2x',
                                  mediaValue: '1200px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=480&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=960&fit=constrain 2x',
                                  mediaValue: '768px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'min-width',
                                  height: 0,
                                },
                                {
                                  renditionPath:
                                    'https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=575&fit=constrain, https://cache.marriott.com/is/image/marriotts7prod/xr-mlexr-trx-at-vommuli-37057-75686:Wide-Hor?wid=1150&fit=constrain 2x',
                                  mediaValue: '767px',
                                  width: 0,
                                  dynamic: true,
                                  smartCropType: null,
                                  damPath:
                                    '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                                  mediaQuery: 'max-width',
                                  height: 0,
                                },
                              ],
                              damPath:
                                '/content/dam/marriott-digital/xr/apec/hws/m/mlexr/en_us/photo/unlimited/assets/xr-mlexr-trx-at-vommuli-37057-75686.tif',
                            },
                            fontSize: 't-subtitle-l',
                            merchandisingCategory: 'nonCobrand',
                            impressionCount: 'false',
                            ctaLink: '/content/mi-luxury-spa/na/en-us/about-us',
                            openInNewTab: true,
                            wcmMode: 'disabled',
                          },
                        },
                        allowedComponents: {
                          components: [],
                          applicable: false,
                        },
                        ':type': 'mi-aem-common-spa/components/container',
                        ':itemsOrder': ['cardlayered_copy_cop'],
                        columnClassNames: {
                          cardlayered_copy_cop: 'aem-GridColumn aem-GridColumn--default--12',
                        },
                        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                        columnCount: 12,
                      },
                    },
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren/card-0/cardcarouselcontaine',
                    ctaProperties: {
                      ctaType: 'primaryButton',
                      linkUrl: '',
                      linkText: '',
                      linkType: 'external',
                      openInANewTab: false,
                    },
                    ':type': 'mi-aem-luxury-spa/components/content/cardcarouselcontainer/v1/cardcarouselcontainer',
                    headerFontSize: 'large',
                    ':itemsOrder': ['card-0', 'card-1', 'card-2'],
                    itemPath:
                      'root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren/card-0/cardcarouselcontaine',
                    totalNumberOfCards: ['card-0', 'card-1', 'card-2'],
                    location: 'Luxury Suites',
                    alignment: 'center',
                    items: [],
                    noOfCardsTablet: 2,
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['cardcarouselcontaine'],
                columnClassNames: {
                  cardcarouselcontaine: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
              'card-1': {
                ':items': {
                  linkbanner_copy: {
                    noOfColumns: '4',
                    componentId: 'bgxdesatylp0dwh9',
                    headerTag: 'h3',
                    impressionTrack: 'false',
                    linkBannerHeader: 'Canada',
                    hideColumDividers: true,
                    trackingProperties: {
                      enableScrollingBehavior: false,
                      trackingDescription: '',
                      impressionTrack: false,
                      description: '',
                      trackingContentPosition: '',
                      atCCeVar48: '',
                      rightArrowDesc: '',
                      cardLocation: '',
                      leftArrowDesc: '',
                      clickTrack: false,
                      location: '',
                      merchandisingCategory: 'nonCobrand',
                      impressionCount: false,
                      trackingTag: '',
                      trackingOfferType: '',
                    },
                    isAuthor: false,
                    path: '/content/mi-luxury-spa/na/en-us/about-us/editorial/jcr:content/root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren/card-1/linkbanner_copy',
                    ':type': 'mi-aem-common-spa/components/content/linkbanner',
                    headerFontSize: 's',
                    columnDetails: [
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Calgary',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Montreal',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: true,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Toronto',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                      {
                        columnHeaderTag: 'h4',
                        columnFontSize: 'm',
                        linkItems: [
                          {
                            linkLabel: 'Vancouver',
                            linkURL: '/content/mi-luxury-spa/na/en-us/destinations',
                            openInNewTab: false,
                          },
                        ],
                      },
                    ],
                    merchandisingCategory: 'nonCobrand',
                    impressionCount: 'false',
                    wcmMode: 'disabled',
                  },
                },
                allowedComponents: {
                  components: [],
                  applicable: false,
                },
                ':type': 'mi-aem-common-spa/components/container',
                ':itemsOrder': ['linkbanner_copy'],
                columnClassNames: {
                  linkbanner_copy: 'aem-GridColumn aem-GridColumn--default--12',
                },
                gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
                columnCount: 12,
              },
            },
            ':itemsOrder': ['card-0', 'card-1', 'headerListItems'],
            itemPath: 'root/responsivegrid/responsivegrid/tabcontainer/page-1/accordioncontaineren',
            headerAlignment: 'left',
            location: 'accordion-2',
            activateDrawerBehavior: false,
            modelFactory: {},
            wcmMode: 'disabled',
          },
        },
        allowedComponents: {
          components: [],
          applicable: false,
        },
        ':type': 'mi-aem-common-spa/components/container',
        ':itemsOrder': ['accordioncontaineren'],
        columnClassNames: {
          accordioncontaineren: 'aem-GridColumn aem-GridColumn--default--12',
        },
        gridClassNames: 'aem-Grid aem-Grid--12 aem-Grid--default--12',
        columnCount: 12,
      },
    },
    subFontSize: 't-subtitle-m',
    cqItemsOrder: ['page-0', 'page-1', 'page-2', 'page-3', 'page-4', 'tabDetails'],
    itemPath: 'root/responsivegrid/responsivegrid/tabcontainer',
    layoutContainer: 'no_border',
    header: '<p>The Regions List</p>\r\n',
    modelFactory: {},
    wcmMode: 'disabled',
  },
  allowedComponents: [
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/wcm/foundation/components/responsivegrid',
      title: 'Layout Container',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/accordion',
      title: 'Accordion',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/accordioncontainer',
      title: 'Accordion Container',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/bannerlayered',
      title: 'Banner Layered',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/brandribbon',
      title: 'Brand Ribbon',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/breadcrumb',
      title: 'Breadcrumb',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/button',
      title: 'Button',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardcarouselcontainer',
      title: 'Card Carousel Container',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardhorizontalfeature',
      title: 'Card Horizontal Feature',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardhorizontalmini',
      title: 'Card Horizontal Mini-Standard',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlayered',
      title: 'Card Layered',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardlinks',
      title: 'Card Links',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cardvertical',
      title: 'Card Vertical',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/carousel',
      title: 'Carousel',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/cobrandcardhorizontalflexible',
      title: 'Cobrand-Card Horizontal Flexible',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/container',
      title: 'Container',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/contentfragment',
      title: 'Content Fragment',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/contentfragmentlist',
      title: 'Content Fragment List',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/download',
      title: 'Download',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/embed',
      title: 'Embed',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/experiencefragment',
      title: 'Experience Fragment',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/herobanner',
      title: 'Common Hero Banner',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/hotelgallerytitle',
      title: 'Hotel Gallery Title',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/content/iconblock',
      title: 'Icon Block',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/image',
      title: 'Image',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/list',
      title: 'List',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/pdfviewer',
      title: 'PDF Viewer',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/progressbar',
      title: 'Progress Bar',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/separator',
      title: 'Separator',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/common/staticwrapper',
      title: 'Static Wrapper',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/tabs',
      title: 'Tabs',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/teaser',
      title: 'Teaser',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/text',
      title: 'Text',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/carousel-container/jcr:content/root/responsivegrid/mi-aem-common-spa/components/title',
      title: 'Title',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/testAV/jcr:content/root/mi-aem-common-spa/components/content/variablecolumncontainer',
      title: 'Variable Column Container',
    },
    {
      path: '/content/mi-aem-common-spa/us/en/testAV/jcr:content/root/mi-aem-common-spa/components/content/tabcontainer',
      title: 'Tab Container',
    },
  ],
  isAuthorMode: false,
};
